import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";

export default function AiReportGo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState("");
  const once = useRef(false);
  useEffect(() => {
    if (once.current) { return; }
    once.current = true;
    api.post(`/airep/decks/${id}/go`)
      .then(({ data }) => navigate(`/ai-report/present/${data.id}`, { replace: true }))
      .catch((e) => setErr(e?.response?.data?.detail || "Impossibile avviare il sondaggio"));
  }, [id, navigate]);
  return (
    <div className="min-h-screen grid place-items-center p-6 text-center" data-testid="airep-go-page">
      {err ? <div className="space-y-3"><p className="text-lg" data-testid="airep-go-error">{err}</p><Link to="/ai-report/app" className="underline">Vai ad AI-Report</Link></div>
        : <p className="text-slate-500">Avvio del sondaggio…</p>}
    </div>
  );
}
